import React from 'react'
import { FormattedMessage } from "react-intl"
import TextField from './textfield'


const DatiUtente = ({ utente, onChange, errors }) => (
  <div className="dati-utente">
    <div className="row">
      <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <h2 className="dati-utente__title">
          <FormattedMessage id="I tuoi dati" defaultMessage="I tuoi dati" />
        </h2>
      </div>
    </div>
    <div className="row">
      <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <div className="row">
          <div className="col-sm-6">
            <div className="field field--horizontal">
              <div className="field__label">
                <FormattedMessage id="Sono un" defaultMessage="Sono un" />:
              </div>
              <form>
                <label htmlFor="tipo-azienda" className="field__label field__radio field__radio--strong">
                  <div className="field__textwrapper">
                    <input id="tipo-azienda" type="radio" name="tipo" value="azienda"
                      checked={utente.tipo === 'azienda'} onChange={e => onChange(e)} />
                    <span className="checkmark"></span>
                  </div>
                  <FormattedMessage id="Azienda/P.IVA" defaultMessage="Azienda/P.IVA" />
                </label>
                <label htmlFor="tipo-privato" className="field__label field__radio field__radio--strong">
                  <div className="field__textwrapper">
                    <input id="tipo-privato" type="radio" name="tipo" value="privato"
                      checked={utente.tipo === 'privato'} onChange={e => onChange(e)} />
                    <span className="checkmark"></span>
                  </div>
                  <FormattedMessage id="Privato" defaultMessage="Privato" />
                </label>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <TextField field="name" persona={utente.id} label="Nome*" onChange={onChange} errors={errors}
            value={utente.name} className="col-sm-6" />
          <TextField field="surname" persona={utente.id} label="Cognome*" onChange={onChange} errors={errors}
            value={utente.surname} className="col-sm-6" />
        </div>
        <div className="row">
          <TextField field="email" persona={utente.id} label="Email*" onChange={onChange} errors={errors}
            type="email" value={utente.email} className="col-sm-6" maxLength={260} note="email-report-note"/>
        </div>
      </div>
    </div>
  </div>
);

export default DatiUtente;